import { Navigate, Route, Routes } from 'react-router-dom';

import { Customers } from './khach-hang';
import { Products } from './san-pham';

export const Categories = () => {
  return (
    <Routes>
      <Route path="khach-hang" element={<Customers />} />
      <Route path="san-pham" element={<Products />} />
      <Route path="vai-tro" element={<Navigate to="/danh-muc/khach-hang" replace />} />
    </Routes>
  );
}
